// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1ibGG","wrapper-nopadding":"wrapper-nopadding__WPsLI","loading":"loading__3ERpV","error":"error__vK9KY","table-loading":"table-loading__1Sq35","empty-val":"empty-val__2jL_D","panelheader-tools":"panelheader-tools__3crjt","propsPanels":"propsPanels__2gGIb","new":"new__1ID2X","marginLm":"marginLm__uOvII","marginRm":"marginRm__1t7Df","fullWidth":"fullWidth__1wdzT","fullHeight":"fullHeight__i4j_S","noData":"noData__1CHA9","card":"card__1lLiM"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/ApplicationDetail/coms/ParseView/coms/ParserAddCard/styles.scss
// module id = 2217
// module chunks = 1